import React from 'react'
import { Route, Switch } from 'react-router-dom'
import FeeOff from './FeeOff'
import IntegralGo from './IntegralGo'
import HappyFriday from './HappyFriday'
import NewYearEvent from './NewYearEvent'
import NewUserEvent from './NewUserEvent'
// import HaiouUserWelfare from './HaiouUserWelfare'  //  remove
import XiniuUserTrans from './XiniuUserTrans'
import NoMatch from '../NoMatch'
import IntegralEvent2 from './IntegralEvent2'
import IntegralEvent3 from './IntegralEvent3'
import IntegralEvent4 from './IntegralEvent4'
// switch (process.env['REACT_APP_CHANNEL']) {
//   case 'haiou':
//     break
//   case 'xiniu':
//     break
// }

class EventsRouter extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={window.PATH.EVENTS.FEE_OFF} component={FeeOff}/>
      <Route path={window.PATH.EVENTS.INTEGRAL_GO} component={IntegralGo}/>
      {/*<Route path={window.PATH.EVENTS.HAIOU_USER_WELFARE} component={HaiouUserWelfare}/>*/}
      <Route path={window.PATH.EVENTS.NEW_USER_EVENT} component={NewUserEvent}/>
      <Route path={window.PATH.EVENTS.HAPPY_FRIDAY} component={HappyFriday}/>
      <Route path={window.PATH.EVENTS.NEW_YEAR_EVENT} component={NewYearEvent}/>
      <Route path={window.PATH.EVENTS.INTEGRAL_EVENT_2} component={IntegralEvent2}/>
      <Route path={window.PATH.EVENTS.INTEGRAL_EVENT_3} component={IntegralEvent3}/>
      <Route path={window.PATH.EVENTS.INTEGRAL_EVENT_4} component={IntegralEvent4}/>
      <Route path={window.PATH.EVENTS.XINIU_USER_TRANS} component={XiniuUserTrans}/>
      <NoMatch/>
    </Switch>
  }
}

export default EventsRouter
